import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-security')!;

export default function ArticleSecurityPage() {
  return <ArticleTemplate article={article} />;
}